import axios from "axios"

export const axiosInstance = axios.create({
    // baseURL: "http://localhost:8080",
    // baseURL: "https://api.goodd-mall.com/",
    baseURL: import.meta.env.VITE_API_BASE_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
})